<template>
  <div class="footer_wrap">
    <!-- 底部栏 -->
    <div class="foot">
      <div class="footBox">
        <div>
          <p style="font-size: 24px;color: rgba(255, 255, 255, 1);margin-bottom: 30px;">扫码关注</p>
          <p style="font-size:16px ;color: rgba(255, 255, 255, 1);margin-bottom: 10px;">请扫码关注公众号，了解更多资讯</p>
          <img src="@/static/common/jry.jpg" style="width: 30%;" />
        </div>
      </div>
      <div class="footBox" style="margin-left: 133px!important;">
        <div v-html="AdData.footer"></div>
      </div>
      <div class="footBox_bootm">
        <a href="https://beian.miit.gov.cn/" target="_blank" style="cursor: pointer;color: rgba(113, 146, 169, 1);text-decoration: none;">{{AdData.recordNumber}}</a>
      </div>
    </div>
  </div>
</template>


<script>
import imgData from "@/data.js";
import { reactive, computed, ref, onMounted } from "vue";
import { submitUserInfo } from "@/api/index";
import { mainStore } from "@/store";
import { storeToRefs } from "pinia";
import { ElMessage } from "element-plus";
import { queryCmsSiteInfo } from "@/api/index.js";
export default {
  setup() {
    const store = mainStore();
    const footerList = [
      {
        title: "注册声明",
      },
      {
        title: "版权声明",
      },
      {
        title: "售后服务",
      },
      {
        title: "隐私声明",
      },
    ];
    const reLoadImg = store.setactiveImgCodeInfo;
    const postUserInfo = () => {
      if (!data.formData.code) {
        ElMessage({
          type: "error",
          message: "请输入验证码",
        });
        return;
      }
      if (
        storeToRefs(store).activeImgCode.value.toLowerCase() ==
        data.formData.code.toLowerCase()
      ) {
        submitUserInfo(data.formData)
          .then((res) => {
            ElMessage({
              type: "success",
              message: "提交成功",
            });
            clearFormData();
            reLoadImg();
          })
          .catch((err) => {
            ElMessage({
              type: "error",
              message: "提交失败，请检查格式是否正确",
            });
          });
      } else {
        ElMessage({
          type: "error",
          message: "请输入正确的验证码",
        });
      }
    };
    const codeImg = computed(() => {
      return storeToRefs(store).activeImg.value;
    });
    const codeKey = computed(() => {
      return storeToRefs(store).activeImgKey.value;
    });
    const clearFormData = () => {
      data.formData.userName = "";
      data.formData.userPhone = "";
      data.formData.content = "";
      data.formData.code = "";
    };
    const toHref = () => {
      window.open("https://beian.miit.gov.cn/", "_blank");
    };

    const AdData = ref({})
    const arr = async () => {
      let res = await queryCmsSiteInfo()
      AdData.value = res.data
    }
    onMounted(async () => {
      await arr()
    })
    const data = reactive({
      formData: {},
      footerList,
      postUserInfo,
      clearFormData,
      toHref,
    });

    return {
      ...data,
      ...imgData,
      codeImg,
      codeKey,
      reLoadImg,
      AdData,
      arr
    };
  },
};
</script>

<style >
@import url("./Footer.css");
</style>